import ProductionPlanningContainer from '@components/containers/productionPlanning';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const ProductionPlanning: FC = () => (
    <AppLayout>
        <ProductionPlanningContainer />
    </AppLayout>
);

export default ProductionPlanning;
